/**
 *  An error that occured while the SDK made a request to the shop API's order builder.
 */
import ApiError from './api.error';
export default class OrderApiError extends ApiError {
    constructor(error) {
        super(error);
        /**
         *  The name of the error.
         */
        this.name = 'OrderApiError';
        // TODO
    }
}
//# sourceMappingURL=orderapi.error.js.map